export const CATEGORY_COLORS: Record<string, string> = {
  needs: "var(--cat-needs)",
  wants: "var(--cat-wants)",
  investments: "var(--cat-investments)",
  income: "var(--cat-income)",
  transfer: "var(--cat-transfer)",
}

export const PERIOD_OPTIONS = [
  { label: "3M", months: 3 },
  { label: "6M", months: 6 },
  { label: "1Y", months: 12 },
  { label: "All", months: 0 },
] as const

/**
 * Max characters a user may type for a transaction description. The API keeps
 * plaintext at 500 and allows up to 2200 for private-mode ciphertext, which is
 * what 500 characters become once encrypted (see apps/api transactions.ts).
 */
export const MAX_DESCRIPTION_LENGTH = 500
